import {round, getFirstEntryByType} from '../utils/utils.js';

const entryType = 'navigation';

export default function navStart([window, performance]) {
    let result;

    let navigation = getFirstEntryByType(performance, entryType);
    if (navigation) {
        result = {
            navigationType: navigation.type,
            protocol: navigation.nextHopProtocol
        };
    } else {
        navigation = performance.timing;
        result = {};
    }

    const {navigationStart = 0, domainLookupStart, domainLookupEnd, redirectStart, redirectEnd, connectStart, connectEnd, secureConnectionStart, requestStart, responseStart} = navigation;
    result.dns = round(domainLookupEnd - domainLookupStart);
    const redirect = round(redirectEnd - redirectStart);
    if (redirect) {
        result.redirect = redirect;
    }

    if (secureConnectionStart) {
        result.tcp = round(secureConnectionStart - connectStart);
        result.ssl = round(connectEnd - secureConnectionStart);
    } else {
        result.tcp = round(connectEnd - connectStart);
    }

    result.ttfb = round(responseStart - navigationStart);
    result.response = round(responseStart - requestStart);

    result.entryType = `${entryType}-start`;
    const {document: {referrer}, location: {href}} = window;
    result.url = fixURL(href, true);
    if (referrer) {
        result.referrer = fixURL(referrer, false);
    }

    return Promise.resolve(result);
}

function fixURL(url, args) {
    const e = /^https?:\/\/(?:www\.)?(.*)/.exec(url);
    if (e) {
        const short = e[1];
        return args || !short ? short : short.replace(/\?.*$/, '');
    }
}
